(function (angular) {
    'use strict';

    angular.module('settings')

        /**
         *
         */
        .factory('myProfileService',
            ['$http', '$q', 'portalConfig', 'sharedDataService',
                function ($http, $q, portalConfig, sharedDataService) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8003';

                    var fac = {
                        getMyProfile: getMyProfile,
                        updateMyProfile: updateMyProfile,
                        updatePassword: updatePassword,
                        updateAvatar: updateAvatar
                    };

                    return fac;

                    function updateAvatar(accountId, userId, avatarUrl) {
                        return $http.put(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/avatar", { url: avatarUrl })
                            .then(updateAvatarComplete)
                            .catch(updateAvatarFailed);

                        function updateAvatarComplete(response) {
                            sharedDataService.setMyProfile(response.data);
                            return response.data;
                        }

                        function updateAvatarFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getMyProfile(accountId, userId) {
                        if (sharedDataService.getMyProfile()) {
                            return $q.resolve(sharedDataService.getMyProfile());
                        }
                        return $http.get(urlBase + "/membership/accounts/" + accountId + "/users/" + userId)
                            .then(getMyProfileComplete)
                            .catch(getMyProfileFailed);

                        function getMyProfileComplete(response) {
                            sharedDataService.setMyProfile(response.data);
                            return response.data;
                        }

                        function getMyProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updateMyProfile(accountId, userId, data) {

                        return $http.put(urlBase + "/membership/accounts/" + accountId + "/users/" + userId, data)
                            .then(updateMyProfileComplete)
                            .catch(updateMyProfileFailed);

                        function updateMyProfileComplete(response) {
                            sharedDataService.setMyProfile(response.data);
                            return response.data;
                        }

                        function updateMyProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updatePassword(accountId, userId, data) {

                        return $http.put(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/password", data)
                            .then(updatePasswordComplete)
                            .catch(updatePasswordFailed);

                        function updatePasswordComplete(response) {
                            return response.data;
                        }

                        function updatePasswordFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);